export const buildSmoothPath = (points, width, height) => {
    const scaleX = x => (x / 100) * width;
    const scaleY = y => (y / 100) * height;
  
    let d = `M ${scaleX(points[0].x)} ${scaleY(points[0].y)}`;
  
    for (let i = 1; i < points.length; i++) {
      const prev = points[i - 1];
      const curr = points[i];
      const cx = (scaleX(prev.x) + scaleX(curr.x)) / 2;
  
      d += ` C ${cx} ${scaleY(prev.y)},
                 ${cx} ${scaleY(curr.y)},
                 ${scaleX(curr.x)} ${scaleY(curr.y)}`;
    }
  
    return d;
  };
  
  export const scaleX = (x, width) => (x / 100) * width;
  export const scaleY = (y, height) => (y / 100) * height;
  